import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Star, ArrowUpRight, House, Clock, Calendar } from "lucide-react";
const cities = [{
  name: "Running Footwear & Gear Audiences",
  rating: "4.9",
  tagline: "TRAINING CYCLE + RACE PREPARATION",
  description: "Reach runners and endurance athletes researching training, racing and performance gear throughout their preparation cycle.",
  homes: "30–120 Days REGISTRATION WINDOW",
  time: "High Intent PURCHASING CYCLE",
  years: "Race Preparation ACTIVE TRAINING",
  tags: ["Audience Signals\xA0", "Conversion", "Scale"],
  image: "https://endurancesportsmediagroup.com/wp-content/uploads/2026/09/Uploaded-footwear-photo.png?v=k89b359npoq"
}, {
  name: "Sports Nutrition & Recovery Audiences",
  rating: "5.0",
  tagline: "PERFORMANCE + PREVENTION + RECOVERY\xA0",
  description: "Connect with endurance athletes exploring fueling, hydration, injury prevention and recovery around training and race events.",
  homes: "Recovery LIFECYCLE STAGE",
  time: "Fueling PERFORMANCE SUPPORT",
  years: "Race Week HIGH ENGAGEMENT",
  tags: ["High Intent", "Timing Windows", "Loyalty"],
  image: "https://endurancesportsmediagroup.com/wp-content/uploads/2026/09/Uploaded-nutrition-photo.png?v=32rm1d7k2z9"
}, {
  name: "Performance Apparel & Wearable Audiences",
  rating: "4.9",
  tagline: "EVENT WEEK + LIVE ATHLETE ENGAGEMENT",
  description: "Reach athletes engaged with endurance events, training, live tracking and performance content.",
  homes: "Live Tracking REAL TIME ENGAGEMENT",
  time: "Event Week HIGH VISIBILITY",
  years: "Community ENDURANCE AUDIENCE",
  tags: ["Awareness", "Impact", "Lifecycle Stages"],
  image: "https://endurancesportsmediagroup.com/wp-content/uploads/2026/09/Uploaded-wearables-photo.png?v=yt0meii11u"
}];
export default function CityServiceGrid() {
  return <section data-section-id="256932" id="proven-results" className="bg-background py-16 md:py-24">
      <div className="container mx-auto px-4 md:px-6">
        <div className="mb-12 text-center max-w-3xl mx-auto">
          <Badge variant="outline" className="mb-4 border-primary text-primary font-default uppercase tracking-widest text-xs py-1 px-3 rounded-md">Brand OPPORTUNITIES</Badge>
          <h2 className="text-4xl md:text-5xl font-default font-bold text-foreground mb-4">Reach Endurance Athletes When Their Intent Matters Most</h2>
          <p className="text-muted-foreground text-lg font-default">ESMG helps brands identify advertising opportunities throughout the athlete journey, from race discovery and training to equipment research, destination travel, event participation and post-race recovery.</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {cities.map((city, i) => <div key={city.name} className="group block h-full" data-index={i}>
              <Card className="h-full overflow-hidden border-border/50 shadow-md transition-all duration-300 hover:border-primary/50 bg-card flex flex-col rounded-lg">
                <div className="relative aspect-[16/9] overflow-hidden bg-muted">
                  <img src={city.image} alt={`${city.name} case study`} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110" loading="lazy" data-wvc-srcset={`${city.image}-wvc-srcset`} data-wvc-sizes={`${city.image}-wvc-sizes`} />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent opacity-60" />
                </div>
                
                <CardContent className="p-6 flex flex-col flex-grow">
                  <div className="flex items-start justify-between mb-1">
                    <h3 className="font-default text-2xl font-bold text-foreground group-hover:text-primary transition-colors">
                      {city.name}
                    </h3>
                    
                  </div>
                  
                  <p className="text-primary text-sm font-default font-semibold uppercase tracking-wider mb-3">
                    {city.tagline}
                  </p>
                  
                  <p className="text-muted-foreground text-sm mb-6 flex-grow font-default">
                    {city.description}
                  </p>
                  
                  <div className={`flex items-center justify-between gap-4 text-center mb-8 pb-8 border-b border-border/50 ${i === 1 ? "-translate-y-3" : ""}`}>
                    <div className="flex flex-col gap-2" title="Metric 1">
                      <span className="font-default font-semibold text-base text-secondary-foreground">{city.homes.split(' ')[0]}</span>
                      <span className="text-xs uppercase tracking-wider font-medium text-muted-foreground">{city.homes.split(' ').slice(1).join(' ')}</span>
                    </div>
                    <div className="flex flex-col gap-2" title="Metric 2">
                      <span className="font-default font-semibold text-base text-secondary-foreground">{city.time.split(' ')[0]}</span>
                      <span className="text-xs uppercase tracking-wider font-medium text-muted-foreground">{city.time.split(' ').slice(1).join(' ')}</span>
                    </div>
                    <div className="flex flex-col gap-2 justify-center flex-1" title="Metric 3">
                      <span className="text-base font-default font-semibold text-secondary-foreground text-center">{city.years.split(' ')[0]}</span>
                      <span className="text-xs uppercase tracking-wider font-medium text-muted-foreground">{city.years.split(' ').slice(1).join(' ')}</span>
                    </div>
                  </div>
                  
                  <div className="flex flex-wrap gap-2 mt-auto">
                    {city.tags.map((tag, tagIndex) => <Badge key={tagIndex} variant="secondary" className="bg-muted text-foreground border-none text-xs px-2 py-0.5 font-default font-medium rounded-md">
                        {tag}
                      </Badge>)}
                  </div>
                </CardContent>
              </Card>
            </div>)}
        </div>

        <div className="mt-16 text-center">
          
        </div>
      </div>
    </section>;
}